import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var backToTopBehavior = function backToTopBehavior() {
  Alpine.data('backToTop', function () {
    return {
      isVisible: false,
      init: function init() {
        this.isVisible = false;
      },
      calculateVisibility: function calculateVisibility() {
        this.isVisible = window.pageYOffset > window.innerHeight;
      },
      bindBackToTopVisibility: {
        '@resize.window.stop.debounce': function resizeWindowStopDebounce() {
          this.calculateVisibility();
        },
        '@scroll.window': function scrollWindow() {
          this.calculateVisibility();
        },
        ':class': function _class() {
          return {
            'pointer-events-none opacity-0 invisible': !this.isVisible
          };
        }
      },
      bindBackToTopBehavior: {
        '@click': function click() {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      }
    };
  });
};